var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "survey-slider", class: _vm.larger ? "is-large" : "" },
    [
      _c(
        "div",
        {
          ref: "barTooltip",
          staticClass: "survey-slider__bar-wrap",
          on: { mousedown: _vm.start },
        },
        [
          _c(
            "yxt-tooltip",
            { ref: "buttonTooltip", attrs: { content: _vm.value_.toString() } },
            [
              _c("div", {
                ref: "bar",
                staticClass: "survey-slider__bar bg-primary-6 pointer",
              }),
            ]
          ),
        ],
        1
      ),
      _c("div", {
        ref: "cover",
        staticClass: "survey-slider__cover bg-primary-6",
      }),
      _c(
        "div",
        { staticClass: "flex flex-between survey-slider__tick" },
        _vm._l(_vm.computedLength, function (item, index) {
          return _c(
            "yxt-tooltip",
            {
              key: item,
              attrs: {
                disabled:
                  _vm.operationType !== "hover" ||
                  (_vm.quesType !== _vm.SurveyQuesType.score &&
                    _vm.quesType !== _vm.SurveyQuesType.evaluation),
                content: _vm.getTooltipContent(item),
              },
            },
            [
              _c("div", { staticClass: "survey-slider__tick-item-wrap" }, [
                _c(
                  "div",
                  {
                    staticClass: "survey-slider__tick-item-wrap",
                    on: {
                      click: function ($event) {
                        return _vm.change(item)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "survey-slider__tick-item",
                        class: { "bg-primary-6-i": _vm.value_ >= item },
                      },
                      [
                        _vm.showSlot("label")
                          ? _c(
                              "div",
                              { staticClass: "survey-slider__label" },
                              [_vm._t("label", null, { index: item })],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "survey-slider__tick-item-text" },
                          [_vm._v(_vm._s(item))]
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          )
        }),
        1
      ),
      _c("div", { staticClass: "survey-slider__line" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }